// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"474":"Overview","950":"MicrogridOverview"}[chunkId] || chunkId) + "." + {"310":"0412ca55","474":"7454018d","950":"c5ffe165"}[chunkId] + ".chunk.js";
};